module.exports = __webpack_public_path__ + "media/assets/baltimore-d87f845c334f3f9a17acf7d9f624c010.png";